<template>
  <v-container
    fill-height
    >
    <Loader />
  </v-container>
</template>
<script>
  import { mapActions, mapGetters } from 'vuex';

  import Loader from '../components/shared/Loader';
  import { i18n } from '../i18n/i18n';

  export default {
    name: 'LoadingScreen',
    components: { Loader },
    computed: {
      ...mapGetters('user', ['currentUser']),
    },
    methods: {
      ...mapActions('user', ['fetchCurrentUser', 'fetchPermissions']),
      ...mapActions('alert', ['showToast', 'hideToast']),

      setUpLanguage() {
        localStorage.setItem('lang-code', this.currentUser.user.locale);
        i18n.locale = this.currentUser.user.locale;
      },
    },
    async created() {
      this.showToast({ type: 'info', message: `${this.$t('FETCHING_DATA')}...` });
      await this.fetchCurrentUser({});
      await this.fetchPermissions({});
      this.setUpLanguage();
      this.hideToast({});
      this.showToast({ type: 'success', message: this.$t('LOGGED_IN') });
      this.$router.push({ name: this.routeName.DASHBOARD });
    },
  };
</script>
